import { connect } from "react-redux";
import { refreshSecMaster } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  setRefreshSecMaster: (data) => {
    dispatch(refreshSecMaster(data));
  },
});

const mapStateToProps = (state) => ({
  refreshSecMaster: state.refreshSecMaster,
});

export default connect(mapStateToProps, mapDispatchToProps);